// EXTERNAL IMPORTS
import React, { Component } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { themr } from "react-css-themr";
import { Link, H } from "@lifepay/rc-ui-toolkit";
import { withRouter } from "react-router";

// ABSOLUTE PATH IMPORTS

// RELATIVE PATH IMPORTS
// importing default component styles
import styles from "./Page.m.scss";

@withRouter
@themr("PageLayout", styles)
export default class PageLayout extends Component {
  static propTypes = {
    theme: PropTypes.object,
    match: PropTypes.object,
    basePath: PropTypes.string,
    pageHeader: PropTypes.string,
    children: PropTypes.node,
  };

  render() {
    const { theme, pageHeader, children } = this.props;
    return (
      // <Page
      //   header={pageHeader}
      //   showHeader={false}
      //   breadcrumb={() => (
      //   )}
      // >
      <div className={classnames(theme.wrapper)}>
        <div className={classnames(theme.content)}>
          <div className={classnames(theme.header)}>
            <Link type="alt" to={`/`}>
              {"главная"}
            </Link>
            <div className={classnames(theme.separator)}>{"->"}</div>
            <H t={"h4"}>{pageHeader}</H>
          </div>
          {children}
        </div>
      </div>
      // </Page>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Private/pages/workflow-processing/Page/Page.js